/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Image_Export_Export_ButtonInputs */



/**
* | output |
* | --- |
* | "Export {count} Images" |
*
* @param {Image_Export_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_export_button = /** @type {((inputs: Image_Export_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Exporter ${i?.count} images`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count}-Bilder exportieren`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esporta ${i?.count} immagini`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Экспорт изображений ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Exportar imágenes ${i?.count}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导出${i?.count}图像`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 画像をエクスポート`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} छवियों को निर्यात करें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Exportar imagens ${i?.count}`)
	return /** @type {LocalizedString} */ (`Export ${i?.count} Images`)
});